import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import {cn} from '../../../lib/utils';

function Switch({
	className,
	...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
	return (
		<SwitchPrimitive.Root
			className={cn(
				'flex items-center h-[14px] w-11 rounded-full bg-gray-300',
				'data-[state=checked]:bg-grey-dark',
				'focus-visible:ring focus-visible:ring-ring overflow-visible',
				className
			)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				className={cn('block h-5 w-5 bg-blue-dark rounded-full shadow transition-transform', 'data-[state=checked]:translate-x-[24px]'
				)}
			/>
		</SwitchPrimitive.Root>
	);
}

export {Switch};
